import AuthLogin from '../src/containers/_views/AuthLogin';
import AuthLogout from '../src/containers/_views/AuthLogout';
import AbstractController from '../src/services/ControllersRepository/AbstractController';

export default class Auth extends AbstractController {
	protected controllerName = 'Auth';

	protected availableActions = ['login', 'logout'];
	protected actionsComponents = {
		login: AuthLogin,
		logout: AuthLogout,
	};
}
